<template>
  <!-- z-20: the country list must stay above the following glass inputs
       (backdrop-filter gives each its own stacking context). -->
  <vue-tel-input
    :model-value="modelValue"
    :auto-default-country="true"
    :valid-characters-only="true"
    :dropdown-options="{
      showSearchBox: true,
      showFlags: true,
      showDialCodeInList: true,
    }"
    :input-options="{
      showDialCode: true,
      autocomplete: 'off',
    }"
    :preferred-countries="preferredCountries"
    data-slot="phone-field"
    class="glass-input relative z-20 flex h-9 rounded-md text-sm focus-within:ring-1 focus-within:ring-ring"
    @validate="onValidate"
    @on-input="(value) => $emit('update:modelValue', value)"
  >
    <template #arrow-icon="{ open }">
      <chevron-down-icon :class="[ 'size-4 text-muted-foreground transition-transform', open && 'rotate-180' ]" />
    </template>
  </vue-tel-input>
</template>

<script>
import { ChevronDown } from '@lucide/vue';

const PREFERRED_COUNTRIES = [ 'hu', 'us', 'gb', 'de', 'at', 'fr', 'it', 'ro', 'pl', 'cz', 'sk', 'es', 'nl', 'se', 'dk', 'no', 'fi' ];

/**
 * Kit-styled phone number input (vue-tel-input with country picker); the
 * widget's inner parts are styled in src/assets/ui.css.
 */
export default {
  name: 'PhoneField',
  components: {
    ChevronDownIcon: ChevronDown,
  },
  props: {
    modelValue: {
      type: String,
      default: '',
    },
  },
  emits: [ 'update:modelValue' ],
  data: () => ({
    preferredCountries: PREFERRED_COUNTRIES,
    valid: false,
  }),
  methods: {
    isValid() {
      return this.valid;
    },
    onValidate(phoneObject) {
      this.valid = !!(phoneObject && (phoneObject.isValid ?? phoneObject.valid));
    },
  },
};
</script>
